import Icon from '@components/text/Icon';
import styles from '@components/typography/Typography.module.css';
import { IconName } from '@utils/iconUtils';

type Props = {
  color: 'secondary700' | 'primary500' | 'success500';
  icon: IconName;
};

const IconBlock = ({ color, icon }: Props) => (
  <div className={`${styles.iconBlock} ${styles[`${color}Background`]}`}>
    <Icon color="white" icon={icon} />
  </div>
);

export default IconBlock;
